import script from "./CircleLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./CircleLoader.vue?vue&type=script&setup=true&lang=js"

import "./CircleLoader.vue?vue&type=style&index=0&id=b64e5534&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b64e5534"]])

export default __exports__